import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../../core/services/config.service';
import { MobileComponent } from '../../../../shared/components/mobile/mobile.component';

@Component({
  selector: 'app-weather-meteogram',
  templateUrl: './meteogram.component.html',
  styleUrl: './meteogram.component.scss',
})
export class MeteogramComponent extends MobileComponent implements OnInit {
  lastSync: Date = new Date();

  constructor(
    breakpointObserver: BreakpointObserver,
    private configService: ConfigService
  ) {
    super(breakpointObserver);
  }

  ngOnInit(): void {
    setInterval(() => (this.lastSync = new Date()), 300000);
  }

  get src(): string {
    return `https://www.yr.no/en/content/${
      this.configService.config.weatherLocation
    }/meteogram.svg?lastSync=${this.lastSync.getTime()}`;
  }

  get tooltip(): string {
    return `Last synced at ${this.lastSync?.toLocaleTimeString()}`;
  }
}
